const conjunctionQuestions2 = [
  {
    id: 1,
    koreanQuestion:
      " 초기 예측이 보였 ____ 감소를 매출에 있어, 회사는 보고했다 상당한 증가를 매출에서 2분기동안",
    question:
      "______ the initial projections indicated a decline in sales, the company reported a significant increase in revenue for the second quarter.",
    choices: {
      A: "Despite",
      B: "Although",
      C: "If",
      D: "Unless",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 문장 분석:\n\n- 양보의 의미를 나타내는 접속사 필요\n- 초기 예측과 실제 결과의 대조\n\n💡 정답 B인 이유:\n- Although는 '~임에도 불구하고'의 의미로 양보절 도입\n- 예상과 다른 결과를 대조적으로 연결\n\n💡 오답 분석:\n- A: Despite는 전치사로 명사/동명사와 함께 사용됨 (Despite the initial projections...)\n- C: If는 조건을 나타내며 문맥상 부적절\n- D: Unless는 '~하지 않는 한'의 의미로 문맥과 맞지 않음\n\n💡 문법 포인트:\n- Although/Though vs Despite/In spite of 구분\n- 양보 접속사의 올바른 사용법",
    translation:
      "초기 예측에서는 매출 감소가 예상되었지만, 회사는 2분기 매출이 상당히 증가했다고 보고했다.",
    type: "conjunction of cause and effect",
  },
  {
    id: 2,
    koreanQuestion:
      "이전 정책이 허용했다 원격근무를 모든 직원들을 위해, 새로운 지침은 요구______ 사무실 출근을 최소 3일 주에",
    question:
      "The previous policy allowed remote work for all employees, ___ the new guidelines require in-office attendance at least three days a week.",
    choices: {
      A: "Despite",
      B: "Whereas",
      C: "If",
      D: "In light of",
    },
    correctAnswer: "B",
    explanation:
      "A:새로운 지침에도 불구하고 B:반면 새로운 지침은 요구한다 C: 만약 새로운 지침이 요구한다면 D: 새로운 지침을 고려하여",
    translation:
      "이전 정책은 모든 직원이 원격 근무를 할 수 있도록 허용했지만, 새로운 지침은 최소한 주 3일 출근을 요구한다.",
    type: "conjunction of contrast",
  },
  {
    id: 3,
    koreanQuestion:
      "예산안이 승인_____ 이사회에 의해, 새 프로젝트는 시작될 것이다 다음 회계 분기에.",
    question:
      "___ the budget proposal is approved by the board, the new project will commence in the next fiscal quarter.",
    choices: {
      A: "Due to",
      B: "If",
      C: "Therefore",
      D: "Despite",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 선택지 분석:\n\n- A: Due to - '예산안 때문에' - 전치사로 명사와 함께 사용됨\n- B: If - '만약 예산안이 승인된다면' - 조건절 도입 접속사\n- C: Therefore - '따라서 예산안이 승인된다' - 결과를 나타내는 접속사\n- D: Despite - '예산안임에도 불구하고' - 양보의 전치사\n\n💡 정답 B인 이유:\n- 문맥상 조건(~하면)을 나타내는 접속사 필요\n- If는 조건절을 이끄는 접속사로 적합함",
    translation:
      "예산안이 이사회에서 승인되면, 새 프로젝트는 다음 회계 분기에 시작될 것이다.",
    type: "conjunction of condition",
  },
  {
    id: 4,
    koreanQuestion:
      "모든 필요한 서류가 제출되______ 마감일까지, 신청서는 처리되지 않을 것이다.",
    question:
      "___ all required documents are submitted by the deadline, the application will not be processed.",
    choices: {
      A: "In case of",
      B: "Subsequently",
      C: "Unless",
      D: "Given",
    },
    correctAnswer: "C",
    explanation:
      "설명:\n\n💡 선택지 분석:\n\n- A: In case of - '~의 경우에는'이라는 의미로 전치사구이므로 뒤에 절이 올 수 없음\n- B: Subsequently - '그 결과, 그 후에'라는 의미로 문맥상 맞지 않음\n- C: Unless - '~하지 않는 한'이라는 의미로 조건의 부정을 나타내는 접속사\n- D: Given - '~을 고려하면'이라는 의미지만 여기서는 문법적으로 맞지 않음\n\n💡 정답 C인 이유:\n- 문맥상 '서류가 제출되지 않으면 처리되지 않는다'는 조건의 부정 관계 필요\n- Unless는 '~하지 않는 한'이라는 의미로 정확히 이 상황에 적합함",
    translation:
      "모든 필수 서류가 마감일까지 제출되지 않으면, 신청서는 처리되지 않을 것이다.",
    type: "conjunction of condition",
  },
  {
    id: 5,
    koreanQuestion:
      "직원들은 요청할 수 있다 추가 휴가를 그들이 (현재) 완료____ 최소 1년의 근속",
    question:
      "Employees may request additional leave _____ they have completed at least one year of service.",
    choices: {
      A: "Apart from",
      B: "Provided that",
      C: "Otherwise",
      D: "As a result of",
    },
    correctAnswer: "B",
    explanation:
      "설명:\n\n💡 선택지 분석:\n\n- A: Apart from - '~을 제외하고'라는 의미로 문맥상 맞지 않음\n- B: Provided that - '~한 경우에 한해'라는 의미로 조건을 나타내는 접속사\n- C: Otherwise - '그렇지 않으면'이라는 의미로 문맥상 맞지 않음\n- D: As a result of - '~의 결과로'라는 의미로 전치사구이므로 뒤에 절이 올 수 없음\n\n💡 정답 B인 이유:\n- 문맥상 '1년 근속을 완료한 경우에 한해'라는 조건이 필요함\n- Provided that은 '~한 경우에 한해'라는 의미로 이 상황에 적합함",
    translation:
      "직원들은 최소 1년의 근속을 완료한 경우에 한해, 추가 휴가를 요청할 수 있다.",
    type: "conjunction of condition",
  },
  {
    id: 6,
    koreanQuestion:
      "회사가 도입____ 새로운 마케팅 전략을, 매출이 (현재) 증가했다. 상당히",
    question:
      "_____ the company implemented a new marketing strategy, sales have increased significantly.",
    choices: {
      A: "Due to",
      B: "Since",
      C: "Therefore",
      D: "Regardless of",
    },
    correctAnswer: "B",
    explanation:
      "A: Due to(~때문에)는 전치사로 뒤에 절이 올 수 없음 B: 회사가 도입한 이후에 (정답) C: Therefore(그러므로) 회사가 도입했다 D: Regardless of(~에 상관없이)는 양보를 나타내는 표현으로 문맥상 맞지 않음",
    translation:
      "회사가 새로운 마케팅 전략을 도입한 이후로, 매출이 상당히 증가했다.",
    type: "conjunction of cause",
  },
  {
    id: 7,
    koreanQuestion:
      "합병이 (현재) 완료____ , 회사는 시작할 것이다 재구성을 회사의 운영의",
    question:
      "_____ the merger has been finalized, the company will begin restructuring its operations.",
    choices: {
      A: "In light of",
      B: "Now that",
      C: "Nonetheless",
      D: "Despite",
    },
    correctAnswer: "B",
    explanation:
      "A: In light of(~을 고려하여)는 전치사로 뒤에 절이 올 수 없음 B: Now that(이제 ~했으므로) - 합병이 마무리되었으므로 적절함 C: Nonetheless(그럼에도 불구하고) - 양보의 의미로 문맥상 맞지 않음 D: Despite(~에도 불구하고)는 전치사로 뒤에 절이 올 수 없음",
    translation: "합병이 마무리되었으므로, 회사는 운영 재구성을 시작할 것이다.",
    type: "conjunction of cause",
  },
  {
    id: 8,
    koreanQuestion:
      "회사는 (현재) 겪고있다 큰 증가를 매출에 있어 이번 분기, _____ 회사는 아직 겪고 있다 재정적 어려움을 운영 비용 상승으로 인해",
    question:
      "The company has experienced a significant increase in sales this quarter, _____ it is still facing financial challenges due to rising operational costs.",
    choices: {
      A: "despite",
      B: "but",
      C: "therefore",
      D: "because of",
    },
    correctAnswer: "B",
    explanation:
      "A: despite(~에도 불구하고)는 전치사로 뒤에 절이 올 수 없음 B: but(하지만) - 대조를 나타내는 접속사로 적절함 C: therefore(따라서) - 결과를 나타내므로 대조 관계에 부적절 D: because of(~때문에)는 전치사로 뒤에 절이 올 수 없음",
    translation:
      "회사는 이번 분기에 매출이 크게 증가했지만, 운영 비용 상승으로 인해 여전히 재정적 어려움을 겪고 있다.",
    type: "conjunction of contrast",
  },
  {
    id: 9,
    koreanQuestion:
      "새로운 소프트웨어 업그레이드는 제공한다 향상된 보안 기능을, ____ 일부 사용자는 (현재) 보고했다 호환성 문제를 구형기기와의 ",
    question:
      "The new software upgrade provides enhanced security features, _____ some users have reported compatibility issues with older devices.",
    choices: {
      A: "therefore",
      B: "so",
      C: "yet",
      D: "since",
    },
    correctAnswer: "C",
    explanation:
      "A: therefore(따라서) - 앞뒤 문장이 대조적 관계이므로 부적절 B: so(그래서) - 결과를 나타내므로 부적절 C: yet(그러나) - 앞뒤 문장이 대조적 관계를 나타내므로 적절 D: since(~이후로, ~때문에) - 시간이나 원인을 나타내므로 부적절",
    translation:
      "새로운 소프트웨어 업그레이드는 보안 기능을 강화하지만, 일부 사용자는 구형 기기와의 호환성 문제를 보고했다.",
    type: "conjunction of contrast",
  },
  {
    id: 10,
    koreanQuestion:
      "프로젝트 마감 기한이 앞당겨졌다 2주, _____ 팀은 해야 했따 초과근무를 맞추기 위해 새로운 일정에.",
    question:
      "The project deadline was moved up by two weeks, _____ the team had to work overtime to meet the new schedule.",
    choices: {
      A: "although",
      B: "so",
      C: "yet",
      D: "in spite of",
    },
    correctAnswer: "B",
    explanation:
      "A: although(비록 ~이지만) - 결과를 나타내는 문맥이므로 부적절 B: so(그래서) - 결과를 나타내므로 적절 C: yet(그러나) - 대조적 관계를 나타내므로 부적절 D: in spite of(~에도 불구하고) - 뒤에 절이 올 수 없고 대조를 나타내므로 부적절",
    translation:
      "프로젝트 마감 기한이 2주 앞당겨졌기 때문에, 팀은 새로운 일정에 맞추기 위해 초과 근무를 해야 했다.",
    type: "conjunction of result",
  },
  {
    id: 11,
    koreanQuestion:
      "CEO는 소개했다 회사의 새로운 비전을 다가오는 해의, _____ 그는 설명했다 전략적 목표들을 달성하기 위해 그것을.",
    question:
      "The CEO introduced the company's new vision for the upcoming year, _____ he outlined the strategic objectives to achieve it.",
    choices: {
      A: "however",
      B: "then",
      C: "although",
      D: "despite",
    },
    correctAnswer: "B",
    explanation:
      "A: however(그러나) - 순차적 관계가 아닌 대조적 관계를 나타내므로 부적절 B: then(그런 다음) - 시간적 순서나 순차적 관계를 나타내므로 적절 C: although(비록 ~이지만) - 대조적 관계를 나타내므로 부적절 D: despite(~에도 불구하고) - 뒤에 절이 올 수 없고 대조를 나타내므로 부적절",
    translation:
      "CEO는 다가오는 해의 새로운 비전을 발표했고, 그 후 이를 달성하기 위한 전략적 목표를 설명했다.",
    type: "conjunction of sequence",
  },
  {
    id: 12,
    koreanQuestion:
      "회사는 마주했다 상당한 재정적 손실을 지난 분기에; _____, 회사는 전념했다 확장하는데 회사의 글로벌 사업을",
    question:
      "The company faced significant financial losses last quarter; _____, it remains committed to expanding its global operations.",
    choices: {
      A: "despite",
      B: "nevertheless",
      C: "because",
      D: "therefore",
    },
    correctAnswer: "B",
    explanation:
      "A: despite(~에도 불구하고) - 뒤에 절이 올 수 없으므로 부적절 B: nevertheless(그럼에도 불구하고) - 앞뒤 문장이 대조적 관계를 나타내므로 적절 C: because(~때문에) - 원인을 나타내므로 부적절 D: therefore(따라서) - 결과를 나타내므로 부적절",
    translation:
      "회사는 지난 분기에 상당한 재정적 손실을 겪었지만, 여전히 글로벌 사업 확장에 전념하고 있다.",
    type: "conjunction of contrast",
  },
  {
    id: 13,
    koreanQuestion:
      "새로운 정책은 목표로 한다 높이는 것을 효율성을 직장에서. _____, 일부 직원들은 우려했다 잠재적 변화에 대해 업무 흐름에 있어.",
    question:
      "The new policy aims to increase efficiency in the workplace. _____, some employees are concerned about potential changes in workflow.",
    choices: {
      A: "however",
      B: "since",
      C: "despite",
      D: "due to",
    },
    correctAnswer: "A",
    explanation:
      "A: however(그러나) - 앞뒤 문장이 대조적 관계를 나타내므로 적절 B: since(~이후로, ~때문에) - 시간이나 원인을 나타내므로 부적절 C: despite(~에도 불구하고) - 뒤에 절이 올 수 없으므로 부적절 D: due to(~때문에) - 뒤에 절이 올 수 없고 원인을 나타내므로 부적절",
    translation:
      "새로운 정책은 직장에서의 효율성을 높이는 것을 목표로 하지만, 일부 직원들은 업무 흐름의 변화에 대해 우려하고 있다.",
    type: "conjunction of contrast",
  },
  {
    id: 14,
    koreanQuestion:
      "회사는 (미래에) 도입할 것이다 유연한 재택근무 정책을 다음 달에. _____, 직원들은 (미래에) 가질것이다 이용할 권한을 확장된 웰니스 프로그램을.",
    question:
      "The company will introduce a flexible work-from-home policy next month. _____, employees will have access to an expanded wellness program.",
    choices: {
      A: "additionally",
      B: "whereas",
      C: "unless",
      D: "albeit",
    },
    correctAnswer: "A",
    explanation:
      "A: additionally(게다가, 또한) - 추가적인 정보를 제공하므로 적절 B: whereas(반면에) - 대조적 관계를 나타내므로 부적절 C: unless(~하지 않는 한) - 조건을 나타내므로 부적절 D: albeit(비록 ~일지라도) - 양보를 나타내므로 부적절",
    translation:
      "회사는 다음 달에 유연한 재택근무 정책을 도입할 예정이며, 추가적으로 직원들은 확장된 웰니스 프로그램을 이용할 수 있을 것이다.",
    type: "conjunction of addition",
  },
  {
    id: 15,
    koreanQuestion:
      "수요가 재생 가능 에너지 솔루션에 대한 증가하고 있따 급격히. _____, 많은 기업들이 투자 중이다 태양광 및 풍력 에너지원에.",
    question:
      "The demand for renewable energy solutions is growing rapidly. _____, many companies are investing in solar and wind power.",
    choices: {
      A: "albeit",
      B: "hence",
      C: "otherwise",
      D: "unless",
    },
    correctAnswer: "B",
    explanation:
      "A: albeit(비록 ~일지라도) - 양보를 나타내므로 부적절 B: hence(따라서) - 원인과 결과의 관계를 나타내므로 적절 C: otherwise(그렇지 않으면) - 조건적 결과를 나타내므로 부적절 D: unless(~하지 않는 한) - 조건을 나타내므로 부적절",
    translation:
      "재생 가능 에너지 솔루션에 대한 수요가 급격히 증가하고 있다. 따라서, 많은 기업이 태양광 및 풍력 에너지원에 투자하고 있다.",
    type: "conjunction of cause and effect",
  },
];

export default conjunctionQuestions2;
